module.exports = __webpack_public_path__ + "img/fashion_58.a9902d32.jpg";